var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvantageIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 20C18.2095 20 20.0004 18.2091 20.0004 16C20.0004 13.7909 18.2095 12 16.0004 12C13.7912 12 12.0004 13.7909 12.0004 16C12.0004 18.2091 13.7912 20 16.0004 20ZM25.0049 8.00293H7.00488C6.4526 8.00293 6.00488 8.45064 6.00488 9.00293V23.0029C6.00488 23.5552 6.4526 24.0029 7.00488 24.0029H25.0049C25.5572 24.0029 26.0049 23.5552 26.0049 23.0029V9.00293C26.0049 8.45064 25.5572 8.00293 25.0049 8.00293ZM8.00488 19.6463V12.3537C9.13065 12.017 10.0184 11.1289 10.3546 10.0029H21.6462C21.9833 11.1319 22.8748 12.0217 24.0049 12.3564V19.6436C22.8729 19.9788 21.9802 20.8711 21.6444 22.0029H10.3563C10.0214 20.8742 9.13261 19.9836 8.00488 19.6463Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon3);
export default __webpack_public_path__ + "static/media/advantage_icon3.55254ac402f0d2789e8386ee99b8761f.svg";
export { ForwardRef as ReactComponent };